// import React from 'react'

// const NoRecord = ({ svg, message }) => {
//     return (
//         <div className='p-1'>
//             <div className=' rounded-lg border h-[60vh] '>
//                 <div className='my-auto flex justify-center align-middle'>
//                     <div className='mt-[100px]' >
//                     <img src={svg} alt="Star Icon" className="w-6 h-6" />
//                     </div>
//                 </div>
//                 <div className='font-mont text-[18px] font-[400] mt-5 text-center'>No Active trials are available. Please create a new trial.</div>
//             </div>

//         </div>
//     )
// }



const NoRecord = ({ svg: SvgComponent, message,classes }) => (
    <div className={classes?classes:''}>
        <div className=''>
            <div className=' rounded-lg border h-[60vh] '>
                <div className='my-auto flex justify-center align-middle'>
                     <div className='mt-[100px]' >
                     <SvgComponent />
                     </div>
                </div>
                <div className='font-mont text-[18px] font-[400] mt-5 text-center'>{message}</div>
            </div>
       </div>

    </div>
);

export default NoRecord